<template>
  <div class="py-6 lg:py-12 flex flex-col justify-center items-center">
    <h1
      class="animate text-4xl md:text-5xl lg:text-8xl text-center font-akira font-bold"
    >
      MENG BOT
    </h1>
    <h2 class="mx-auto max-w-4xl mt-5 lg:mt-8 lg:text-lg text-center">
      Experience seamless and lighting-fast trading on the go with our
      free-to-use Website bot
    </h2>
    <h3 class="mt-1 lg:mt-3 text-lg lg:text-xl text-blue-600">
      The fastest trading bot
    </h3>
  </div>
</template>
<script>
export default {
  name: "HomeView",
};
</script>
<style lang="scss">
h1.animate {
  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #565460 0%,
    #645d6c 29%,
    #cbbec2 67%,
    #eeeee7 100%
  );
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
</style>
